import * as React from 'react';
import { st, classes } from './FillerContainer.st.css';
var FillerContainer = function (_a) {
    var _b = _a.isCut, isCut = _b === void 0 ? false : _b, isInPopper = _a.isInPopper, popper = _a.popper, event = _a.event, isLastFiller = _a.isLastFiller, isNextWeekFirstFiller = _a.isNextWeekFirstFiller, handleEventClick = _a.handleEventClick, isMobile = _a.isMobile, _c = _a.className, className = _c === void 0 ? '' : _c, isAgenda = _a.isAgenda, isWeekend = _a.isWeekend, isToday = _a.isToday;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { role: "button", onClick: function (e) {
                if (e.detail === 0) {
                    handleEventClick(e, true);
                }
                else {
                    handleEventClick(e);
                }
            }, className: st(classes.root, {
                isCut: isCut,
                isInPopper: isInPopper,
                isLastFiller: isLastFiller,
                isNextWeekFirstFiller: isNextWeekFirstFiller,
                isMobile: isMobile,
                isAgenda: isAgenda,
                isWeekend: isWeekend,
                isToday: isToday,
            }, className) }, event),
        popper));
};
export default FillerContainer;
//# sourceMappingURL=FillerContainer.js.map